'use client'
const SOLANA_GENESIS_HASH = 'genesis-hash';

export { SOLANA_GENESIS_HASH };
